export default __webpack_public_path__ + "static/media/dashboard-img.80f63ffe.png";